import { styled, Paper, Stack, Grid, Typography } from "fashion/fabrics";
import { StoreIcon } from "fashion/icons";

const CenterStack = styled(Stack)(() => ({
  justifyContent: "space-between",
  alignItems: "center",
}));

const PricingPaper = styled(Paper)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  height: "100%",
  padding: theme.spacing(2),
}));

const CodexPhysicalPricingGrid = () => (
  <Grid container rowSpacing={2} columnSpacing={2}>
    <Grid size={{ xs: 6, sm: 3, md: 2 }}>
      <PricingPaper elevation={8}>
        <CenterStack gap={1}>
          <StoreIcon fontSize="large" sx={{ color: "success.main" }} />
          <Typography variant="h6">50 cards</Typography>
          <Typography variant="h5" color="success">
            $50
          </Typography>
          <Typography variant="body1" color="text.secondary">
            $1/card
          </Typography>
        </CenterStack>
      </PricingPaper>
    </Grid>
    <Grid size={{ xs: 6, sm: 3, md: 2 }}>
      <PricingPaper elevation={8}>
        <CenterStack gap={1}>
          <StoreIcon fontSize="large" sx={{ color: "success.main" }} />
          <Typography variant="h6">100 cards</Typography>
          <Typography variant="h5" color="success">
            $90
          </Typography>
          <Typography variant="body1" color="text.secondary">
            $0.9/card
            <Typography ml={0.5} variant="caption" color="text.disabled">
              (-10%)
            </Typography>
          </Typography>
        </CenterStack>
      </PricingPaper>
    </Grid>
    <Grid size={{ xs: 6, sm: 3, md: 2 }}>
      <PricingPaper elevation={8}>
        <CenterStack gap={1}>
          <StoreIcon fontSize="large" sx={{ color: "success.main" }} />
          <Typography variant="h6">250 cards</Typography>
          <Typography variant="h5" color="success">
            $200
          </Typography>
          <Typography variant="body1" color="text.secondary">
            $0.8/card
            <Typography ml={0.5} variant="caption" color="text.disabled">
              (-20%)
            </Typography>
          </Typography>
        </CenterStack>
      </PricingPaper>
    </Grid>
    <Grid size={{ xs: 6, sm: 3, md: 2 }}>
      <PricingPaper elevation={8}>
        <CenterStack gap={1}>
          <StoreIcon fontSize="large" sx={{ color: "success.main" }} />
          <Typography variant="h6">500 cards</Typography>
          <Typography variant="h5" color="success">
            $350
          </Typography>
          <Typography variant="body1" color="text.secondary">
            $0.7/card
            <Typography ml={0.5} variant="caption" color="text.disabled">
              (-30%)
            </Typography>
          </Typography>
        </CenterStack>
      </PricingPaper>
    </Grid>
    <Grid size={{ xs: 6, sm: 3, md: 2 }}>
      <PricingPaper elevation={8}>
        <CenterStack gap={1}>
          <StoreIcon fontSize="large" sx={{ color: "success.main" }} />
          <Typography variant="h6">1,000 cards</Typography>
          <Typography variant="h5" color="success">
            $600
          </Typography>
          <Typography variant="body1" color="text.secondary">
            $0.6/card
            <Typography ml={0.5} variant="caption" color="text.disabled">
              (-40%)
            </Typography>
          </Typography>
        </CenterStack>
      </PricingPaper>
    </Grid>
    <Grid size={{ xs: 6, sm: 3, md: 2 }}>
      <PricingPaper elevation={8}>
        <CenterStack gap={1}>
          <StoreIcon fontSize="large" sx={{ color: "success.main" }} />
          <Typography variant="h6">1,500 cards</Typography>
          <Typography variant="h5" color="success">
            $750
          </Typography>
          <Typography variant="body1" color="text.secondary">
            $0.5/card
            <Typography ml={0.5} variant="caption" color="text.disabled">
              (-50%)
            </Typography>
          </Typography>
        </CenterStack>
      </PricingPaper>
    </Grid>
  </Grid>
);

export default CodexPhysicalPricingGrid;
